import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
  "lang": "中文",
  // 菜单
  "menu": {
    "media": "媒体",//媒体
    "data": "数据",//数据
    "docking": "对接",//对接
    "Account": "账户",//账户
    "reconciliation": "对账",//对账
    "operator": "当前操作账号：",//当前操作账号
  },
  "title": {
    "appManage": "应用管理", // 应用管理
    "appList": "应用列表",// 应用列表
    "adsenseManage": "广告位管理",// 广告位管理
    "adsenseList": "广告位列表",// 广告位列表
    "blockManage": "屏蔽管理",// 屏蔽管理
    "companyInfo": "企业信息",// 企业信息
    "paymentInfo": "结算",// 结算
  },
  // 通用字段
  "common": {
    "all": "全部",//全部
    "customColumn": "自定义列",//自定义列
    "OS": "操作系统", //操作系统
    "app": "应用",//应用
    "adZone": "广告位",//广告位
    "co_mode": "合作模式", //合作模式
    "country": "国家", //国家
    "subDim": "细分维度",//细分维度
    "addApp": "添加应用",// 添加应用
    "lookApp": "查看应用",// 查看应用
    "editApp": "编辑应用",// 编辑应用
    "searchContent": "搜索内容",// 搜索内容
    "searchID": "搜索ID",// 搜索ID
    "searchRule": "搜索规则名", //搜索规则名
    "APPplatform": "应用平台",// 应用平台
    "selectAppPlat": "请选择应用平台",// 选择应用平台
    "enterContent": "请输入内容",// 请输入内容
    "selectTemplate": "请选择模板名称",// 请选择模板名称
    "selectApp": "请选择所属应用",// 请选择所属应用
    "selectMode": "请选择合作模式",// 请选择合作模式
    "selectFlowType": "请选择广告类型",// 请选择广告类型
    "selectArea": "请选择合作地区",// 请选择合作地区
    "select": "请选择",// 请选择
    "enter": "请填写",// 请填写
    "search": "查询",// 查询
    "addAdsense": "添加广告位",//添加广告位
    "addAdsenseBatch": "批量添加广告位",//批量添加广告位
    "lookAdsense": "查看广告位",//查看广告位
    "editAdsense": "编辑广告位",//编辑广告位
    "yuan": "元",//元
    "meiyuan": "美元",//美元
    "featureConfig": "能力配置",//能力配置
    "informationMothod": "信息流渲染方式",
    "miniProgram": "可投小程序",
    "quickApp": "可投快应用",
    "appWakeup": "可投应用唤起",
    "APKDownload": "可投下载apk",
    "engagementMaterial": "可投诱导素材",
    "appstoreUrl": "商店地址",
    "website": "Website",
    "appstoreUrl_ph": "请填写Google play或Apple App store的URL",
    "website_ph": "请填写商店关联的官网地址，例如：https://bluex.com",
    "paid": "付费",
    "free": "免费",
    "enterRuleName": "请输入规则名",//请输入搜索规则名
    "addRule": "添加规则",// 添加规则
  },
  // 复制
   "copy": {
    "copy" : "复制",  
    "copySuccess": "已成功复制到剪切板",
    "copyError": "复制失败",
    "copyTips": "请先创建APP后再试",
  },
  // 表格字段
  "table": {
    "appId": "应用id", //应用id
    "appName": "应用名称", //应用名称
    "appPackageName": "应用包名", //应用包名
    "appPlat": "应用平台", //应用平台
    "appCate": "应用类目", //应用类目
    "accessMode": "接入方式", //接入方式
    "appDaily": "应用日活", //应用日活
    "appType": "应用类型", //应用类型
    "appKeyword": "关键词", //应用关键词
    "wxAppid": "微信appId", //微信appid
    "status": "状态", //状态
    "operation": "操作", //操作
    "adsenseId": "广告位ID",//广告位ID
    "adsenseName": "广告位名称",//广告位名称
    "application": '所属应用',//所属应用
    "templateName": '模板名称',//模板名称
    "coMode": '合作模式',//合作模式
    "pdPrice": 'Flat-CPM',//Flat-CPM
    "zhpdPrice": "固定CPM",
    "coArea": '合作地区',//合作地区
    "area": '地区',//地区
  },
  // 操作
  "operation": {
    "edit": "编辑", //编辑
    "detail": "详情", //详情
    "adsense": "广告位", //广告位
    "delete": "删除", //删除
  },
  // 状态
  "status": {
    "approved": "已通过",//审核通过
    "checkPending": "待审核",//待审核
    "rejected": "已驳回",//审核驳回
    "open": "已开启", // 已开启
    "closed": "已关闭", //已开启
  },
  // 校验
  "required": {
    "name": "请输入名称", //请输入名称
    "packageName": "包名不能为空", //包名不能为空
    "os": "请选择应用平台", //请选择应用平台
    "cate": "请选择应用类目", //请选择应用类目
    "dau": "应用日活不能为空", //应用日活不能为空
    "desc": "应用关键词不能为空", //应用关键词不能为空
    "number": "请输入数值类型", //请输入数值类型
    "app": "请选择所属应用", //请选择所属应用
    "adName": "请输入广告位名称", //请输入广告位名称
    "template": "请选择模板", //请选择模板
    "templateSize": "请选择模板尺寸", //请选择模板尺寸
    "pdPrice": "请填写Flat-CPM", //请填写Flat-CPM
    "zhpdPrice": "请填写固定CPM", //请填写Flat-CPM
    "pdPriceLimit": "请输入0-100之间的数，最多两位小数", //pd校验
    "style": "请选择样式", //请选择样式
    "config": "请选择配置", //请选择配置
    "callbackUrl": "请填写回调URL", //请填写回调URL
    "secretKey": "请填写密钥", //请填写密钥
    "pdPriceNumber": "Flat-CPM的取值必须为数字", // Flat-CPM的取值必须为数字
    "pdPriceRange": "Flat-CPM的取值必须在 0-999.99 之间", // Flat-CPM的取值必须在 0-999.99 之间
    "pdPriceFloat": "Flat-CPM最多保留 2 位小数" // Flat-CPM最多保留 2 位小数
  },
  // 数据页面字段
  "statInfo": {
    "time": "时间",//时间
    "dimension": "维度",//维度
    "timeRange": "时间范围",//时间范围
    "to": "至",//至
    "startDate": "开始日期",//开始日期
    "endDate": "结束日期",//结束日期
    "templateName": '模板名称',//模板名称
    "trendChart": '趋势图表',//趋势图表
    "summaryReport": '汇总报表',//汇总报表
    "close": "收起", //收起
    "open": "展开", //展开
    "noData": "暂无数据", //暂无数据
    "date": "日期时间", //日期时间
    "rawReq": "原始请求",//原始请求
    "bid": "出价", //出价
    "exposure": "曝光", //曝光
    "exposureRate": "曝光率", //曝光率
    "click": "点击", //点击
    "clickRate": "点击率", //点击率
    "CPM": "CPM", //CPM
    "profit": "预估收益", //预估收益
    "export": "导出数据", //导出数据
    "exportStream": "流式导出数据", //流式导出数据
    "exportStreamFail": "导出失败", //导出失败
    "os_type": "操作系统", //操作系统
    "application": "应用", //应用
    "media_ad_slot": "广告位", //广告位
    "co_mode": "合作模式", //合作模式
    "country": "国家", //国家
    "template_id": "广告类型", //广告类型
    "table": "统计表格", //统计表格
    "downloadTip": "开发者后台数据仅供参考，实际结算以对账邮件为准",//开发者后台数据仅供参考，实际结算以对账邮件为准
  },
  // 对账相关
  "reconciliation": {
    "placementMonth": "投放月份",
    "templateName": "模板名称",
    "adZone": "广告位",
    "summaryReport": "月度数据汇总报表",
    "downloadTip": "开发者后台数据仅供参考，实际结算以对账邮件为准",//开发者后台数据仅供参考，实际结算以对账邮件为准
    "generateReconciliation": "生成对账单",// 生成对账单
    "taxRate": "开票税率",//开票税率
    "monthsCheck": "投放月份不能为空",//投放月份不能为空
    "companyName": "公司主体全称",//公司主体全称
    "companyNamePlaceholder": "请输入公司主体全称",//请输入公司主体全称
    "companyNameCheck": "公司主体全称不能为空",//公司主体全称不能为空
    "batchDownloadBill": "批量下载对账单", //批量下载对账单
    "downloadBill": "下载对账单", //下载对账单
    "confirmDownloadBill": "确认生成", //确认生成
    "rawReq": "原始请求",//原始请求
    "bid": "出价", //出价
    "exposure": "曝光", //曝光
    "exposureRate": "曝光率", //曝光率
    "click": "点击", //点击
    "clickRate": "点击率", //点击率
    "CPM": "CPM", //CPM
    "profit": "预估收益", //预估收益
  },
  // sdk相关
  "sdk": {
    "interaction": "请选择广告交互", //请选择广告交互
    "deviceId": "请填写设备ID", //请填写设备ID
    "adId": "请填写广告位ID", //请填写广告位ID
    "flowType": "广告类型", //广告类型
    "createNum": "创建数量", //创建数量
    "adTemplate": "广告模板", //广告模板
    "templateSize": "模板尺寸", //模板尺寸
    "styleConfig": "样式配置", //样式配置
    "rendeMode": "渲染方式",//渲染方式
    "platformRender": "平台渲染",//平台渲染
    "selfRender": "自渲染",//自渲染
    "styleSelection": "样式选择",//样式选择
    "stylelprt": "左图右文",//左图右文
    "styleltrp": "左文右图",//左文右图
    "stylefb": "上文下图",//上文下图
    "styleab": "上图下文",//上图下文
    "elConfig": "元素配置",//元素配置
    "elImg": "图片",//图片
    "elCover": "封面",//封面
    "elVideo": "视频",//视频
    "elTitle": "标题",//标题
    "elDesc": "描述",//描述
    "elIcon": "icon", //icon
    "elProduct": "品牌名称",//品牌名称
    "elButton": "按钮文案",//按钮文案
    "videoSound": "视频声音", //视频声音
    "closeBtn": "关闭按钮", //关闭按钮
    "hidden": "隐藏", //隐藏
    "display": "显示", //显示
    "soundOff": "静音", //静音
    "soundRelease": "声音外放", //声音外放
    "videoAutoplay": "视频自动播放", //视频自动播放
    "videoNoAuto": "不自动播放", //不自动播放
    "webcast": "有网络播放", //有网络播放
    "wifiAuto": "WIFI下自动播放", //WIFI下自动播放
    "callback": "回调控制", //回调控制
    "noServer": "无需服务器判断", //无需服务器判断
    "needServer": "需要服务器判断", //需要服务器判断
    "callbackUrl": "回调URL",//回调URL
    "secretKey": "密钥",//密钥
    "newSecretKey": "生成新密钥",//生成新密钥
    "adsenseShow": "广告位展示",//广告位展示
  },
  // 对接中心
  "docking": {
    "docApi": "API对接",//api对接
    "docSdk": "SDK对接",//sdk对接
    "docSdkWord": "SDK接入文档",//sdk接入文档
    "docSdkTest": "SDK测试工具",//sdk测试工具
    "API": "API接入文档",//API接入文档
    "tipOne": "详细文档请查看",//详细文档请查看
    "tipTwo": "，如需帮助，请联系相关对接人。",//如需帮助，请联系相关对接人
    "tipThree": "接入指南",//接入指南
    "document": "文档",//文档
    "updateDate": "更新日期",//更新日期
    "version": "版本号",//版本号
    "domobAdx": "多盟ADX对接文档（多盟作为预算侧）",//多盟ADX对接文档（多盟作为预算侧）
    "templateFile": "模板文件",//模板文件
    "proto": "多盟proto文件",//多盟proto文件
    "domobSdkWord": "多盟SDK对接文档",//多盟sdk对接文档 
    "AndroidWord": "安卓接入文档",//安卓接入文档
    "IOSWord": "IOS接入文档",//IOS接入文档
    "mediaDataApi": "媒体数据API接口",//媒体数据API接口 
    "domobSdk": "多盟SDK",//多盟sdk
    "updateLog": "更新日志", //更新日志
    "sdkTipOne": "为sdk接入提供的接入前测试工具，在媒体app模拟线上真实页面渲染及广告请求，提升接入效率及体验，详见 操作指南",
    "deviceName": "设备名称", //设备名称
    "deviceID": "设备ID", //设备ID
    "deviceIDP": "请输入imei/oaid/idfa设备号",//请输入imei/oaid/idfa设备号
    "deviceType": "设备类型", //设备类型
    "testStatus": "测试状态", //测试状态
    "addDevice": "新建设备信息", //新建设备信息
    "adInteraction": "广告交互", //广告交互
    "testSaveTip": "完成新建后预计15分钟后可在测试设备上预览",//完成新建后预计15分钟后可在测试设备上预览
  },
  "message": {
    "errorComplete": "请输入完整的信息", //请输入完整的信息
    "successSava": "保存成功", //保存成功
    "successLogin": "登录成功", //登录成功
    "errorLogin": "登录失败", //登录失败
    "registLogin": "注册成功", //注册成功
    "delete": "删除成功", //删除成功
    "add": "添加成功", //添加成功
    "edit": "编辑成功", //编辑成功
    "emailRegisted": "邮箱已经注册", //邮箱已经注册
    "telRegisted": "手机号已经注册", //手机号已经注册
    "completeCompanyInfo":"你的企业信息不完整，请先完善必填项再继续操作", // 你的企业信息不完整，请先完善必填项再继续操作
    "cancel": "取消", //取消
    'confirmModify':"确认修改",//确认修改
    'confirmCompanyInfo':"确认企业信息",//确认企业信息
    "completeForm":"请完善表单必填项",//请完善表单必填项
    "mofifyPrompt": "企业信息属于敏感内容，修改后将立即生效。请确认是否继续修改。",//企业信息属于敏感内容，修改后将立即生效。请确认是否继续修改。
    "listEmpty":"暂无下载数据", //暂无下载数据
    "confirmDelete": "确认删除该条规则？", // 确认删除该条规则？
    "deleteMessage": "所有绑定的应用和广告位将会被解绑", //所有绑定的应用和广告位将会被解绑
    "noData": "暂无数据", //暂无数据
  },
  "login": {
    "login": "登录", //登录
    "companyInfoLogin": "登录", //登录
    "regist": "注册", //注册
    "emailLogin": "邮箱登录", //邮箱登录
    "mobileLogin": "手机号登录", //手机号登录
    "imgCode": "图形验证码", //图形验证码
    "autoLogin": "下次自动登录", //下次自动登录
    "welcomeLogin": "欢迎登录",//欢迎登录
    "welcomeSignup": "欢迎注册",//欢迎注册
    "companyInfo": "企业信息",//欢迎注册企业信息
    "companyInfoUse": "此信息将帮助我们为您设置发布者账户",//此信息将帮助我们为您设置发布者账户
    "devPlatform": "开发者变现平台",//开发者变现平台
    "forget": "重置密码", //重置密码
    "register": "没有账户？前往注册", //没有账户？前往注册
    "toLogin": "已有账号？返回登录", //已有账号？返回登录
    "cooperation": "合作联系：pub-support@domob.cn", //合作联系：15811494601
    "company": "多盟睿达科技(中国)有限公司", //多盟睿达科技(中国)有限公司
    "password": "请输入密码", //请输入密码
    "email": "邮箱/手机号", //邮箱/手机号
    "nameCheck": "用户名不能为空", //用户名不能为空
    "pwdCheck": "密码不能为空", //密码不能为空
    "confirmPwdCheck": "请再次确认密码", //请再次确认密码
    "min": "最少为6个字符", //最少为6个字符
    "codeCheck": "图片验证码不能为空", //图片验证码不能为空
    "codeCheckFalse": "验证码输入有误", //验证码输入有误
    "submit": "提交",//提交
    "setPwd": "设置密码(不能少于6个字符)",//设置密码(不能少于6个字符)
    "confirmPwd": "请确认密码",//请再次确认密码
    "pwdNotMatch": "两次输入的密码不一致", //两次输入的密码不一致
    "enterprise": "企业账号",//企业账号
    "personal": "个人账号",//个人账号
    "phoneError": "手机号输入有误", //手机号输入有误
    "emailCheck": "请输入邮箱", //请输入邮箱
    "emailError": "邮箱格式异常", //邮箱格式异常
    "pwdAgain": "请再次输入密码", //请再次输入密码
    "pwdDiff": "两次输入密码不一致", //两次输入密码不一致
    "loginIng": "登录中", //登录中
    "msg1": "短信验证码已发送至您手机，请注意查收！",//短信验证码已发送至您手机，请注意查收！
    "msg2": "为了保证您的账号安全，请完成邮箱验证后登录。",//为了保证您的账号安全，请完成邮箱验证后登录。
    "msg3": "发送邮件",//发送邮件
    "msg4": "邮箱验证成功！",//邮箱验证成功！
    "msg5": "邮箱验证失败！",//邮箱验证失败！
    "msg6": "链接已经无效，可能是以下原因：",//链接已经无效，可能是以下原因：
    "msg7": "链接已经过期；",//链接已经过期；
    "msg8": "链接有可能已经使用过；",//链接有可能已经使用过；
    "msg9": "您修改了帐户的邮箱。",//您修改了帐户的邮箱。
    "msg10": "邮箱验证码已发送至您邮箱，请注意查收！",//邮箱验证码已发送至您邮箱...
  },
  "forget": {
    "title": "多盟开发者后台", //多盟开发者后台
    "type": "找回密码方式", //找回密码方式
    "valid": "账号验证", //账号验证
    "resetPwd": "重设密码", //重设密码
    "phone": "手机找回", //手机找回
    "email": "邮箱找回", //邮箱找回
    "tel": "手机号", //手机号
    "Email": "邮箱", //邮箱
    "msgCode": "短信验证码", //短信验证码
    "emailCode": "邮箱验证码", //邮箱验证码
    "toEmail": "使用邮箱找回", //使用邮箱找回
    "toPhone": "使用手机找回", //使用手机找回
    "showEinfoMsg": "我们刚给你发了一封电子邮件，请注意查收！", //我们刚给你发了一封电子邮件，请注意查收！
    "next": "下一步", //下一步
    "getCode": "获取验证码", //获取验证码
    "sendEmail": "发送验证邮箱", //发送验证邮箱
    "getEmail": "获取验证邮箱", //获取验证邮箱
    "codeError": "验证码输入有误", //验证码输入有误
    "phoneCheck": "手机号不能为空", //手机号不能为空
    "smsCheck": "短信验证码不能为空", //短信验证码不能为空
    "verifyCheck": "验证码不能为空", //验证码不能为空
    "newPwd": "请输入新密码", //请输入新密码
    "renewPwd": "请再次输入新密码", //请再次输入新密码
    "confirm": "确认修改", //确认修改
    "resetSuccess": "密码重置成功", //密码重置成功
    "congratulate": "恭喜您，已经成功设置新的密码", //恭喜您，已经成功设置新的密码
    "loginNow": "立即登录", //立即登录
    "resetError": "密码重置失败！", //密码重置失败！
    "beover": "链接已经无效，或页面已经过期", //链接已经无效，或页面已经过期
    "resetPass": "再次申请重置密码", //再次申请重置密码
    "reInputPsd": "密码不一致，请重新输入", //密码不一致，请重新输入
  },
  "companyInfo": {
    "companyName": "企业法定名称", //企业法定名称
    "brandNameEN": "企业英文简称", //企业英文简称
    "brandNameCN": "企业中文简称", //企业中文简称
    "country": "国家/地区", // 国家/地区
    "industry": "行业分类", //行业分类
    "websiteURL": "官网",//官网
    "companyNameCheck": "企业法定名称不能为空",
    "companyNameStartEndCheck": "企业名称不能数字开头或结尾",
    "companyNameCNCharCheck": "企业名称不能包含非法字符",
    "companyNameLengthCheck": "企业名称长度需在2-120字符之间",
    "companyNameSpecialCharCheck": "企业名称不允许包含特殊字符或Emoji",
    "brandNameENCheck": "企业英文简称不能为空", // 企业英文简称
    "countryCheck": "国家/地区不能为空", //国家/地区不能为空
    "industryCheck": "行业分类不能为空", //行业分类不能为空
    "companyNameFormatCheck": '只能输入中文或英文，不可包含特殊字符',//只能输入中文或英文，不可包含特殊字符
    "brandNameENFormatCheck": '只能包含英文字符',//只能包含英文字符
    "brandNameENUniqueCheck": '不能与企业名称完全一致',//不能与企业名称完全一致
    "brandNameCNFormatCheck": '不可包含特殊字符',//不可包含特殊字符
    "brandNameCNChineseCheck": '必须包含中文字符',//必须包含中文字符
    "websiteFormatCheck": '请输入正确的 URL 格式',//请输入正确的 URL 格式
    "companyInfo": "企业信息", //企业信息
    "companyNamePlaceholder": "请填入注册的公司名称", //请填入注册的公司名称
    "prompt": "必须和你注册的企业名称匹配", // 必须和你注册的企业名称匹配
    "urlExplame": "https://example.com",//websiteURL的例子
    "edit": "编辑", //编辑
    "save": "保存", //保存
    "cancel": "取消", //取消
    "reset": "重置", //重置
  },
  "block": {
    "blockContent": "屏蔽内容", //屏蔽内容
    "effectScope": "生效范围", //生效范围
    "ruleName": "规则名称", //规则名称
    "blockApp": "屏蔽应用", //屏蔽应用
    "blockDomain": "屏蔽域名", //屏蔽域名
    "blockCategory": "屏蔽类别", //屏蔽类别
    "blockKeyword": "屏蔽关键词",//屏蔽关键词
    "effectScope": "生效范围", //生效范围
    "app": "应用", //应用
    "domain": "域名", //域名
    "category": "类别", //类别
    "keyword": "关键词",//关键词
  },
  "dialog": {
    "addRule": "新建", //新建屏蔽规则
    "editRule": "编辑", //编辑屏蔽规则
    "enterApp": "请输入包名，包名之间以换行符分隔",//请输入包名，包名之间以换行符分隔
    "enterDomain": "请输入域名，域名之间以换行符分隔", //请输入域名，域名之间以换行符分隔
    "enterCategory": "请选择类别", //请选择类别
    "enterKeyword": "请输入关键词，关键词之间以换行符分隔", //请输入关键词，关键词之间以换行符分隔
    "enterRuleName": "请输入规则名",//请输入搜索规则名  
    "selectEffectScope": "请选择生效范围", //请选择生效范围
    "appInvaildMessage": "个无效的应用包名已忽略", //个无效的应用包名已忽略
    "appRepeatMessage": "个重复的应用包名已忽略", //个重复的应用包名已忽略
    "domainInvaildMessage": "个无效的域名已忽略", //个无效的域名已忽略
    "domainRepeatMessage": "个重复的域名已忽略", //个重复的域名已忽略
    "confirmLeave": "确定离开", //确定离开
    "message": "如果离开，您填写的内容将不会被保存", //如果离开，您填写的内容将不会被保存
    "yes": "是", //是
    "no": "否", //否
  },
  "save": "保存", // 保存
  "confirm": "确认",
  "cancel": "取消", // 取消
  "logout": "退出登录",//退出登录
  ...zhLocale
}